import React, { useCallback } from 'react';
import Animated from 'react-native-reanimated';
import { StyleSheet, View, TouchableWithoutFeedback } from 'react-native';
import { useOpenSearch } from 'features/transactions/hooks/useOpenSearch';
import Spacer from 'design-system/Spacer';
import Indicator from 'design-system/Indicator';
import { AppView } from 'design-system/AppView';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import FakeSearchBar from 'design-system/FakeSearchBar';
import { selectListAccounts } from 'reducers/selectors';
import { selectIsCreditScoreFirstInFeed } from 'reducers/selectors/organise';
import { useAppSelector } from 'store/hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import Amplitude from 'utils/amplitude';
import Links from 'utils/links';
import { logAnalyticsEvent } from 'utils/packages/rnFirebase';
import { YEARLY_REPORT_FEED } from 'actions/deviceSettingTypes';
import CreditScoreFeedCard from 'features/credit-score/components/CreditScoreFeedCard';
import FeedHeader from '../components/FeedHeader';
import FeedContent from '../components/FeedContent';
import Overview from '../components/overview/Overview';
import NoBankConnections from '../components/needs-fix/NoBankConnections';
import SpaceBanner from '../components/SpaceBanner';
import YearlyReportBanner from '../components/reports/YearlyReportBanner';
const Feed = withAnimatedNavigationHeader(({ scrollHandler }) => {
    const feed = useAppSelector((store) => store.feed.feed);
    const hasAccounts = useAppSelector(selectListAccounts).length > 0;
    const isCreditScoreFirst = useAppSelector(selectIsCreditScoreFirstInFeed);
    const openSearchScreen = useOpenSearch();
    const openSearch = useCallback(() => {
        openSearchScreen();
        Amplitude.logEvent('Accounts.OpenSearch', { source: 'feed' });
    }, [openSearchScreen]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const didDismissYearlyReportFeed = useAppSelector((store) => store.deviceSettings[YEARLY_REPORT_FEED]);
    const openReport = useCallback((data) => {
        if (data.webUrl) {
            Links.openLink(data.webUrl);
        }
        Amplitude.logEvent('Report.Open', { type: data.type });
        logAnalyticsEvent('Open_Report', { type: data.type });
    }, []);
    return (<AppView withFrame={false}>
        {!feed.cards.overview ? (<View style={styles.indicatorContainer}>
            <Indicator dark/>
          </View>) : (<Animated.ScrollView scrollEventThrottle={16} onScroll={scrollHandler}>
            <View style={paddingHorizontalStyle}>
              <SpaceBanner />
              <TouchableWithoutFeedback onPress={openSearch} style={styles.searchBarBtn}>
                <View pointerEvents="box-only" style={styles.flex}>
                  <FakeSearchBar />
                </View>
              </TouchableWithoutFeedback>
            </View>
            <Overview data={feed.cards.overview}/>
            {isCreditScoreFirst ? <CreditScoreFeedCard /> : null}
            {hasAccounts ? (<>
                {!!feed.cards.yearlyReportCoverInfo &&
                    !didDismissYearlyReportFeed && (<YearlyReportBanner data={feed.cards.yearlyReportCoverInfo} openReport={openReport} isDismissible withFrame/>)}
                <FeedContent latestTransactions={feed.cards.latestTransactions}/>
              </>) : (<NoBankConnections />)}
            <Spacer h={16}/>
          </Animated.ScrollView>)}
      </AppView>);
}, ({ colors }) => ({
    headerHeight: 64,
    renderContent: () => <FeedHeader />,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    flex: {
        flex: 1,
    },
    searchBarBtn: {
        flex: 1,
        // @ts-ignore
        cursor: 'pointer',
    },
    indicatorContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
});
export default Feed;
